<section class="container-style">
  <div class="row">
    <form class="" [formGroup]="formStorePrice">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <app-custom-audit-info [userNameCreate]="storePriceModel.userNameCreate"
            [createDate]="storePriceModel.createDate" [userNameUpdate]="storePriceModel.userNameUpdate"
            [updateDate]="storePriceModel.updateDate"
            [reserveSpace]="true"></app-custom-audit-info>
        </div>
      </div>
      <div class="row custom-padding">
        <div class="row">
          <div class="col field-branch">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [required]="true" [recovery]="true"
              [list]="listBranches" (onChangeSelect)="getBranch($event, true)">
            </app-custom-select>
          </div>
          <div class="col field-store">
            <app-custom-autocomplete formControlName="storeId" [labelText]="'Bodega'" [required]="true"
              [recovery]="true" [list]="listStores" (onChangeSelect)="changeStore($event)">
            </app-custom-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col field-article">
            <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
              [required]="true" [recovery]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
              [iconExtraButton]="'pi pi-external-link'" (clickExtraButton)="openArticleModal()"
              (onChangeSelect)="getArticle($event)"></app-custom-autocomplete>
            <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
              [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
              (selectedItems)="changeArticle($event)" hidden>
            </app-custom-modal>
          </div>
          <div class="col field-unit-value">
            <app-custom-input-decimal formControlName="unitValue"
              [labelText]="'Vr.Unitario'"></app-custom-input-decimal>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row">
    <div class="buttons-container">
      <app-custom-button [title]="'Guardar'" [label]="'Guardar'" (onClick)="send()"></app-custom-button>
      <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
        (onClick)="close(false)"></app-custom-button>
    </div>
  </div>
</section>